import React, { FunctionComponent, useEffect } from "react";
import styles from "./DownloadLinks.module.scss";
import DownloadLinksProps from "./DownloadLinksProps.interface";

import DownloadLink from "./components/DownloadLink/DownloadLink";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useAnchorIdentifier from "hooks/useAnchorIdentifier";
import isBrowserContext from "helpers/isBrowserContext";

const DownloadLinks:FunctionComponent<DownloadLinksProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const identifier = useAnchorIdentifier(props.settings.anchorIdentifier);

    // ANIMATION
    const controls = useAnimation();
    const { ref, inView } = useInView({ threshold: 0.3 });

    const animateUp = {
        visible: { y: 0, opacity: 1 },
        hidden: { y: 80, opacity: 0 }
    };
    const animateDown = {
        visible: { y: 0, opacity: 1 },
        hidden: { y: -80, opacity: 0 }
    };

    const selectAnimation = props.settings.animation && props.settings.animation.length > 0 ? props.settings.animation[0].content._contentType : undefined;
    const selectVariants = selectAnimation === "animateUp" ? animateUp : selectAnimation === "animateDown" ? animateDown : undefined;
    const repeatAnimation = props.settings.animation && props.settings.animation.length > 0 ? props.settings.animation[0].content.repeatAnimation : false;

    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
        if (!inView && repeatAnimation) {
            controls.start("hidden");
        }
    }, [controls, inView]);

    return (
        <motion.section className={combineClasses([styles.wrapper, ...wrapperClasses])} id={identifier} ref={ref} initial={isBrowserContext() ? "hidden" : "shown"} animate={controls} variants={selectVariants} transition={{ duration: 0.4 }}>
            <div className={styles.container}>

                {/* Headline */}
                {props.content.headline ? (
                    <h1 className={styles.headline}>{props.content.headline}</h1>
                ) : null}

                {/* Links */}
                <div className={styles.links_wrapper}>
                    {props.content.links && props.content.links.length > 0 ? props.content.links.map((link)=> {
                        return <DownloadLink key={link.contentUdi} {...link}/>;
                    }):null}
                </div>

            </div>
        </motion.section>
    );
};

export default DownloadLinks;
